import { OrganizerPortalSummary } from './types';

/** Was der Verweis in den Veranstalter-Bereich auf der Startseite anzeigt. */
export interface OrganizerShortcut {
  /** Kleine Zeile darüber — sagt, worum es geht. */
  eyebrow: string;
  /** Name des Veranstalters bzw. „3 Veranstalter". */
  title: string;
  /** Kurzer Stand: kommende Events, offene Prüfungen — oder die Namen bei mehreren. */
  detail: string;
  /** Beschriftung des Knopfs. */
  cta: string;
  /** Bei genau einem Veranstalter dessen ID, sonst null (dann führt der Weg über die Auswahl). */
  singleOrganizerId: number | null;
}

/**
 * Verweis in den Veranstalter-Bereich für die Startseite (Web und App).
 *
 * Null, solange das Konto keinen Veranstalter pflegt — dann gibt es nichts zu zeigen, und ein
 * normaler Besucher sieht die Startseite unverändert.
 */
export function organizerShortcut(organizers: OrganizerPortalSummary[]): OrganizerShortcut | null {
  if (organizers.length === 0) return null;

  if (organizers.length === 1) {
    const o = organizers[0];
    const parts = [
      o.upcomingEventCount === 1 ? '1 kommendes Event' : `${o.upcomingEventCount} kommende Events`,
    ];
    if (o.pendingEditCount > 0) parts.push(`${o.pendingEditCount} in Prüfung`);
    return {
      eyebrow: 'DEIN VERANSTALTER-BEREICH',
      title: o.name,
      detail: parts.join(' · '),
      cta: 'Verwalten',
      singleOrganizerId: o.id,
    };
  }

  return {
    eyebrow: 'DEINE VERANSTALTER',
    title: `${organizers.length} Veranstalter`,
    detail: organizers.map(o => o.name).join(', '),
    cta: 'Verwalten',
    singleOrganizerId: null,
  };
}
